import { TextField } from '@mui/material';
import type { ComponentProps } from 'react';
import {
  Control,
  ControllerRenderProps,
  FieldPath,
  FieldValues,
  useController,
} from 'react-hook-form';

type BannedProps = keyof ControllerRenderProps;
type MuiTextFieldWithBannedProps = Omit<ComponentProps<typeof TextField>, BannedProps>;

type LAITextFieldProps<TFieldValues extends FieldValues> = {
  name: FieldPath<TFieldValues>;
  control: Control<TFieldValues>;
  disabled?: boolean;
  showErrorMessage?: boolean;
} & MuiTextFieldWithBannedProps;

/**
 * A controlled TextField that integrates react-hook-form with MUI
 */
export const LAITextField = <TFieldValues extends FieldValues>({
  name,
  disabled,
  control,
  showErrorMessage = true,
  ...props
}: LAITextFieldProps<TFieldValues>) => {
  const { field, fieldState } = useController({ name, control, disabled });
  return (
    <TextField
      {...props}
      {...field}
      error={!!fieldState.error}
      helperText={showErrorMessage ? fieldState.error?.message : undefined}
    />
  );
};
